var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInfoIcon = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4C5F66",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.969 4.673a1.093 1.093 0 1 1-2.187 0 1.093 1.093 0 0 1 2.187 0M8.785 7.669v3.605a.91.91 0 1 1-1.82 0V7.67a.91.91 0 0 1 1.82 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm4.579 12.454a6.478 6.478 0 0 1-9.196.038 6.474 6.474 0 0 1 .038-9.196 6.478 6.478 0 0 1 9.196-.038 6.474 6.474 0 0 1-.038 9.196z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 0a7.875 7.875 0 1 0 0 15.75 7.875 7.875 0 0 0 0-15.75zm4.579 12.454a6.478 6.478 0 0 1-9.196.038 6.474 6.474 0 0 1 .038-9.196 6.478 6.478 0 0 1 9.196-.038 6.474 6.474 0 0 1-.038 9.196z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-icon.28540951.svg";
export { ForwardRef as ReactComponent };